export const panelStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
};

export const formGridStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '14px',
};

export const actionsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
};
